import React, { CSSProperties, FC } from 'react';
import { User } from '@vromo/models';

type ProfileImageProps = {
    url?: string | null;
    user: User | null;
    size: number;
    className?: string;
    style?: CSSProperties;
};

const ProfileImage: FC<ProfileImageProps> = ({ url, user, size = 34, className, style }) => {
    if (url) {
        return (
            <div
                className={className}
                style={{
                    width: size,
                    height: size,
                    backgroundImage: `url(${url})`,
                    backgroundSize: 'cover',
                    borderRadius: '50%',
                    backgroundPosition: 'center',
                    verticalAlign: 'middle',
                    ...style
                }}
            />
        );
    }
    else if (user) {
        return (
            <ProfilePlaceholder
                initials={user.initials}
                id={user.id!}
                size={size}
                className={className}
                style={style}
            />
        );
    }
    else {
        return null;
    }
};

type PlaceholderProps = {
    initials: string;
    id: number;
    size?: number;
    className?: string;
    style?: CSSProperties;
};

export const ProfilePlaceholder: FC<PlaceholderProps> = ({
    initials = "",
    id,
    size = 34,
    className,
    style
}) => {
    return (
        <svg
            style={{
                borderRadius: '50%',
                width: size,
                height: size,
                verticalAlign: 'middle',
                ...style
            }}
            className={className}
            viewBox="0 0 128 128">
            <circle fill={`hsl(${(id || 0) % 361},76%, 69%)`} cx="64" cy="64" r="64" />
            <text
                fontFamily="aktiv-grotesk"
                fontSize="54"
                fontWeight="500"
                fill="#FFFFFF"
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="central">
                {initials.toUpperCase()}
            </text>
        </svg>
    );
};

export default ProfileImage;
